import { KeyedOption } from '@/shared/enums/generic.enum';
import { FeedbackCategory, FeedbackRole, FeedbackStatus } from './feedback.enum';

export const feedbackCategoryOptions: KeyedOption<FeedbackCategory>[] = [
    { labelKey: 'FEEDBACK.CATEGORY.BUG', value: FeedbackCategory.BUG },
    { labelKey: 'FEEDBACK.CATEGORY.FEATURE_REQUEST', value: FeedbackCategory.FEATURE_REQUEST },
    { labelKey: 'FEEDBACK.CATEGORY.IMPROVEMENT', value: FeedbackCategory.IMPROVEMENT },
    { labelKey: 'FEEDBACK.CATEGORY.QUESTION', value: FeedbackCategory.QUESTION },
    { labelKey: 'FEEDBACK.CATEGORY.GENERAL', value: FeedbackCategory.GENERAL }
];

export const feedbackStatusOptions: KeyedOption<FeedbackStatus>[] = [
    { labelKey: 'FEEDBACK.STATUS.NEW', value: FeedbackStatus.NEW },
    { labelKey: 'FEEDBACK.STATUS.IN_REVIEW', value: FeedbackStatus.IN_REVIEW },
    { labelKey: 'FEEDBACK.STATUS.RESOLVED', value: FeedbackStatus.RESOLVED },
    { labelKey: 'FEEDBACK.STATUS.CLOSED', value: FeedbackStatus.CLOSED }
];

export const feedbackRoleOptions: KeyedOption<FeedbackRole>[] = [
    { labelKey: 'FEEDBACK.ROLE.ADMIN', value: FeedbackRole.ADMIN },
    { labelKey: 'FEEDBACK.ROLE.WEALTH_MANAGER', value: FeedbackRole.WEALTH_MANAGER },
    { labelKey: 'FEEDBACK.ROLE.RELATIONSHIP_MANAGER', value: FeedbackRole.RELATIONSHIP_MANAGER },
    { labelKey: 'FEEDBACK.ROLE.CLIENT', value: FeedbackRole.CLIENT }
];
